// extracted by mini-css-extract-plugin
export default {"form":"Search_form__KGT+E","searchBtn":"Search_searchBtn__kEs6t","input":"Search_input__PXR0c"};